import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { SapApi, catalogoPersonal } from 'utils/helpers/dictionaries';

export interface SapPosition {
  code: string;
  externalName_es_ES?: string;
  jobTitle?: string;
  jobCode?: string;
  vacant?: boolean;
  effectiveStatus?: string;
  effectiveStartDate?: string;
  division?: string;
  department?: string;
}

export interface SapJobCode {
  externalCode: string;
  name?: string;
  jobFunction?: string;
}


function escapeODataValue(value: string): string {
  return value.trim().replace(/'/g, "''");
}

export const sapApi = createApi({
  reducerPath: SapApi.sapApi,
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_SAP_URL }),
  endpoints: (builder) => ({

    getPicklist: builder.query<any, { catalogName: string; select?: any; filter?: any; father?: any, languages?: any }>({
      query: ({ catalogName, select, filter, father, languages }) => {
        let sUrl = `${process.env.REACT_APP_SAP_PICKLIST}?value=${catalogName}`;
        if (select) sUrl = `${sUrl}&select=${select}`;
        if (filter) sUrl = `${sUrl}&filter=${filter}`;
        if (father) sUrl = `${sUrl}&father=${father}`;
        if (languages) sUrl = `${sUrl}&languages=${languages}`;
        return sUrl;
      },
    }),

    getEntity: builder.query<any, { catalogName: string; select?: any; filter?: any; father?: any, languages?: any }>({
      query: ({ catalogName, select, filter, father, languages }) => {
        let sUrl = `${process.env.REACT_APP_SAP_ENTITY}?value=${catalogName}`;
        if (select) sUrl = `${sUrl}&select=${select}`;
        if (filter) sUrl = `${sUrl}&filter=${filter}`;
        if (father) sUrl = `${sUrl}&father=${father}`;
        if (languages) sUrl = `${sUrl}&languages=${languages}`;
        return sUrl;
      },
    }),

    getPersonalInfoByEmail: builder.query<any, { email: string }>({
      query: ({ email }) => {
        return {
          url: `${process.env.REACT_APP_SAP_ENTITY}`,
          params: {
            value: 'EmpEmployment',
            expand: 'userNav',
            filter: `userNav/email eq '${email}'`,
            select: 'userNav/name'
          },
        };
      },
    }),

    getPhotoByEmail: builder.query<any, { email: string }>({
      query: ({ email }) => {
        return {
          url: `${process.env.REACT_APP_SAP_ENTITY}`,
          params: {
            value: 'EmpEmployment',
            expand: 'userNav,photoNav',
            filter: `userNav/email eq '${email}'`,
            select: 'userNav/name',
          },
        };
      },
    }),


    getPosition: builder.query<SapPosition[], { code: string }>({
      query: ({ code }) => ({
        url: `${process.env.REACT_APP_SAP_ENTITY}`,
        params: {
          value: catalogoPersonal.Position,
          filter: `code eq '${escapeODataValue(code)}'`,
          select: [
            'code',
            'externalName_es_ES',
            'jobTitle',
            'jobCode',
            'vacant',
            'effectiveStatus',
            'effectiveStartDate',
            'division',
            'department',
          ].join(','),
        },
      }),
    }),

    // Chapter autoritativo de la posición: FOJobCode.jobFunction apunta a FOJobFunction.
    getJobCode: builder.query<SapJobCode[], { jobCode: string }>({
      query: ({ jobCode }) => ({
        url: `${process.env.REACT_APP_SAP_ENTITY}`,
        params: {
          value: catalogoPersonal.FOJobCode,
          filter: `externalCode eq '${escapeODataValue(jobCode)}'`,
          select: 'externalCode,name,jobFunction',
        },
      }),
    }),

  }),
});

export const {
  useGetPicklistQuery,
  useGetEntityQuery,
  useGetPersonalInfoByEmailQuery,
  useGetPhotoByEmailQuery,
  useLazyGetPositionQuery,
  useLazyGetJobCodeQuery,
  useLazyGetEntityQuery,
  useLazyGetPicklistQuery,
} = sapApi;
